import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {QuotationsService} from "../../data/quotations.service";

@Component({
  selector: 'quotation-approve',
  templateUrl: './quotation-approve.component.html',
  styleUrls: ['./quotation-approve.component.scss']
})
export class QuotationApproveComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private QuotationsService: QuotationsService
  ) { }

  @Input() quotation_revision_id: number;
  @Input() quotationNumber: string;

  @Output() onClose=new EventEmitter();
  @Output() onSuccess=new EventEmitter();

  ngOnInit(): void {
    this.addControls();
  }
  addControls() {
    this.form = this.formBuilder.group(
        {
          comments: new FormControl('' ),
        }
    );
  }
  get formControls() {
    return this.form.controls;
  }
  save() {
    let data={
      quotation_revision_id: this.quotation_revision_id,
      comments: this.formControls.comments.value
    }
    this.QuotationsService.approve(data).subscribe(
        ()=>{},
        (error: any)=>console.error(error),
        ()=>this.onSuccess.emit()
    )
  }
  close() {
    this.onClose.emit();
  }
}
